'use strict';


var nodeMap = require('../node.map.js'),
    group = {
        name: '',
        list: [],
        active: null
    };


module.exports = function ( value, callback ) {
    var self = this,
        $layout = document.createElement('div'),
        $icon = document.createElement('div'),
        $text = document.createElement('div');


    while ( nodeMap.data[this.id].firstChild ) {
        nodeMap.data[this.id].removeChild(nodeMap.data[this.id].firstChild);
    }

    $text.innerText = this.name;

    $icon.className = 'theme-icon ' + this.icon;
    $text.className = '';

    $layout.className = 'mag-component-layout';

    $layout.appendChild($icon);
    $layout.appendChild($text);

    if ( this.config && this.config.group ) {
        if ( group.name !== this.config.group ) {
            group.name = this.config.group;
            group.list.splice(0);
            group.active = null;
        }

        $icon = document.createElement('div');
        $layout.appendChild($icon);

        group.list.push(this);

        if ( this.config.enabled  ) {
            group.active = this;
            $icon.className = 'theme-icon theme-icon theme-icon-ok';
        }
    }

    // $node here
    nodeMap.data[this.id].appendChild($layout);

    nodeMap.data[this.id].onclick = function () {
        if ( self.config.group ) {
            if ( group.active !== self ) {
                self.emit('check', function ( result ) {
                    if ( result ) {
                        group.active.config.enabled = !!group.active.config.enabled;
                        nodeMap.data[group.active.id].firstChild.lastChild.className = 'theme-icon theme-icon';
                        group.active = self;
                        self.config.enabled = !!self.config.enabled;
                        $icon.className = 'theme-icon theme-icon theme-icon-ok';
                    }
                });
            }
        } else {
            self.emit('check', function ( result ) {
                if ( result ) {
                    if ( self.config.enabled ) {
                        $icon.className = 'theme-icon theme-icon theme-icon-ok';
                    } else {
                        $icon.className = 'theme-icon theme-icon';
                    }
                    self.config.enabled = !!self.config.enabled;
                }
            });
        }
    };

    callback();
};
